import { DisplayType, RECEIVE_STATUS_DETAILS } from "../components/ReceiveList/constants";

export function getStatusDetail(
	status: string,
	displayType?: DisplayType,
	failureReasons?: string
): { message: string; title: string } {
	const statusDetails = (RECEIVE_STATUS_DETAILS as Record<string, any>)[status] || RECEIVE_STATUS_DETAILS.default;

	const getValue = (type: "title" | "message", defaultValue: string): string => {
		if (status === "Incomplete" && failureReasons) {
			if (failureReasons === "EDIInvoiceMissing") {
				return type === "title" ? "Receives Missing EDI" : statusDetails.message;
			} else {
				return type === "title" ? "Issues" : statusDetails.message;
			}
		}

		const value = type === "title" ? statusDetails.title : statusDetails.message;

		if (typeof value === "object" && displayType) {
			return value[displayType as string] || value["PurchaseOrders"] || defaultValue;
		}
		return typeof value === "string" ? value : defaultValue;
	};

	return {
		message: getValue("message", "receives"),
		title: getValue("title", statusDetails.title || status),
	};
}
